// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__16-xQ","notes":"Notes_notes__19-YC","note":"Notes_note__2kPHo","markdown":"Notes_markdown__2OAdy"};